import sleeping1 from "../images/sleeping/sleeping1.png";
import sleeping2 from "../images/sleeping/sleeping2.png";
import sleeping3 from "../images/sleeping/sleeping3.png";
import sleeping4 from "../images/sleeping/sleeping4.png";
import sleeping5 from "../images/sleeping/sleeping5.png";
import sleeping6 from "../images/sleeping/sleeping6.png";
import sleeping7 from "../images/sleeping/sleeping7.png";
import sleeping8 from "../images/sleeping/sleeping8.png";
import sleeping9 from "../images/sleeping/sleeping9.png";
import sleeping10 from "../images/sleeping/sleeping10.png";
import sleeping11 from "../images/sleeping/sleeping11.png";
import sleeping12 from "../images/sleeping/sleeping12.png";

const sleeping = [
  {
    category: "sleeping",
    id: "sleeping1",
    name: "Fireside 0C Double Sleeping Bag",
    price: 276.00,
    image: `${sleeping1}`,
  },
  {
    category: "sleeping",
    id: "sleeping2",
    name: "Creekside 0C Sleeping Bag",
    price: 85.00,
    image: `${sleeping2}`,
  },
  {
    category: "sleeping",
    id: "sleeping3",
    name: "Draco Jr.-5 Down Sleeping Bag",
    price: 163.00,
    image: `${sleeping3}`,
  },
  {
    category: "sleeping",
    id: "sleeping4",
    name: "Creekside -5C Sleeping Bag",
    price: 103.00,
    image: `${sleeping4}`,
  },
  {
    category: "sleeping",
    id: "sleeping5",
    name: "Camino Traveller 15/22C Sleeping Bag",
    price: 55.00,
    image: `${sleeping5}`,
  },
  {
    category: "sleeping",
    id: "sleeping6",
    name: "Little Dipper +5C Sleeping Bag",
    price: 63.00,
    image: `${sleeping6}`,
  },
  {
    category: "sleeping",
    id: "sleeping7",
    name: "Delphinus -9C Down Sleeping Bag",
    price: 223.00,
    image: `${sleeping7}`,
  },
  {
    category: "sleeping",
    id: "sleeping8",
    name: "Draco -9C Down Sleeping Bag",
    price: 223.00,
    image: `${sleeping8}`,
  },
  {
    category: "sleeping",
    id: "sleeping9",
    name: "Delphinus 0C Down Sleeping Bag",
    price: 182.00,
    image: `${sleeping9}`,
  },
  {
    category: "sleeping",
    id: "sleeping10",
    name: "Draco 0C Down Sleeping Bag",
    price: 182.00,
    image: `${sleeping10}`,
  },
  {
    category: "sleeping",
    id: "sleeping11",
    name: "Centaurus -18C Sleeping Bag",
    price: 155.00,
    image: `${sleeping11}`,
  },
  {
    category: "sleeping",
    id: "sleeping12",
    name: "Centaurus +5C Sleeping Bag",
    price: 126.00,
    image: `${sleeping12}`,
  },
];

export default sleeping;
